module.exports = __webpack_public_path__ + "static/CarLoans-NZ-F1-cace6c2148590b2a905c510c0c508ce5.webp";